module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/AlertMessage-5879d95da34d2755a793d6568cfe4ebe.jpg";